export default {
  data: () => ({}),
  computed: {
    error() {
      if (this.$route.meta.error) return this.$route.meta.error;
    },
  },
  created() {},
  mounted() {},
  methods: {},
  components: {},
};
